import { createFileRoute } from "@tanstack/react-router";
import AdminMaterialsPage from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms")({
  component: AdminMaterialsPage,
});
